import { defineComponent as _defineComponent } from 'vue'

export enum Type {
  Personal,
  Library,
}

export enum Variant {
  UnderFrameQuota,
  AtFrameQuota,
  OverFrameQuota,
  Upgrade,
  UpgradeSingleStep,
  UnderPadletQuota,
  AtPadletQuota,
  OverPadletQuota,
  FileSize,
  SignUp,
  Continue,
  StartFreeTrial,
}

const __default__ = {}

import { trackEvent } from '@@/bits/analytics'
import { numberToHumanSize } from '@@/bits/numbers_helper'
import { FileSizeUnit } from '@@/bits/units'
import { LibraryType } from '@@/enums'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzDivider, { OzDividerColorScheme, OzDividerOrientation } from '@@/library/v4/components/OzDivider.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzLoadingSpinner from '@@/library/v4/components/OzLoadingSpinner.vue'
import OzMembershipTierGrid, { OzMembershipTierGridVariant } from '@@/library/v4/components/OzMembershipTierGrid.vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'GoldMembershipTier',
  props: {
    variant: null,
    type: { default: Type.Personal },
    libraryType: { default: null },
    isExpanded: { type: Boolean },
    isWhiteboard: { type: Boolean },
    monthlyPrice: { default: undefined },
    annualPrice: { default: undefined },
    isLoadingPlanInformation: { type: Boolean },
    isLoadingAdvertisedQuotas: { type: Boolean },
    advertisedWhiteboardFrameQuota: null,
    advertisedFileSizeQuota: null,
    advertisedFileSizeQuotaUnit: { default: FileSizeUnit.MB },
    advertisedWallsQuota: { default: undefined },
    wallsUsed: { default: undefined },
    whiteboardFramesUsed: { default: undefined },
    fileSize: { default: undefined },
    isUserLoggedIn: { type: Boolean, default: undefined },
    continueUrl: { default: undefined },
    xChecked: { type: Boolean, default: false }
  },
  emits: ['upgrade', 'continue', 'upgrade-monthly', 'upgrade-annual'],
  setup(__props: any) {

const props = __props as { variant: Variant, type: Type, libraryType: LibraryType | null, isExpanded: boolean, isWhiteboard: boolean, monthlyPrice: string, annualPrice: string, isLoadingPlanInformation: boolean, isLoadingAdvertisedQuotas: boolean, advertisedWhiteboardFrameQuota: number, advertisedFileSizeQuota: string, advertisedFileSizeQuotaUnit: FileSizeUnit, advertisedWallsQuota: number, wallsUsed: number, whiteboardFramesUsed: number, fileSize: number, isUserLoggedIn: boolean, continueUrl: string, xChecked: boolean };





const xPaymentSchedules = ref<boolean>(false)

const isPadletQuotaOrFileSizeVariant = computed<boolean>(
  () =>
    props.variant === Variant.UnderFrameQuota ||
    props.variant === Variant.AtFrameQuota ||
    props.variant === Variant.OverFrameQuota ||
    props.variant === Variant.UnderPadletQuota ||
    props.variant === Variant.AtPadletQuota ||
    props.variant === Variant.OverPadletQuota ||
    props.variant === Variant.FileSize,
)

const colorScheme = computed<OzBoxColors | null>(() => {
  if (isPadletQuotaOrFileSizeVariant.value) return OzBoxColors.Secondary
  if (
    props.variant === Variant.Upgrade ||
    props.variant === Variant.UpgradeSingleStep ||
    props.variant === Variant.Continue ||
    props.variant === Variant.StartFreeTrial
  )
    return OzBoxColors.Highlight
  return null
})

const showPaymentSchedules = (): void => {
  trackEvent('Billing', 'Chose Gold plan', null, null, null)
  xPaymentSchedules.value = true
}

return { __sfc: true,Type, Variant, props, xPaymentSchedules, isPadletQuotaOrFileSizeVariant, colorScheme, showPaymentSchedules, numberToHumanSize, FileSizeUnit, LibraryType, OzBox, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzDivider, OzDividerColorScheme, OzDividerOrientation, OzIcon, OzLoadingSpinner, OzMembershipTierGrid, OzMembershipTierGridVariant }
}

})